var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 65,
    viewBox: "0 0 60 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 55,
    width: 60,
    height: 10,
    rx: 5,
    fill: "url(#paint0_linear_508_0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3948 56.3631C26.036 57.7173 27.7477 58.955 29.5 60.1629C31.2561 58.971 32.9594 57.7032 34.6052 56.3631C37.3488 54.1104 39.9307 51.6678 42.3321 49.0533C47.8679 43.0002 53.875 34.2252 53.875 24.375C53.875 21.174 53.2445 18.0044 52.0196 15.0471C50.7946 12.0898 48.9992 9.4027 46.7357 7.13927C44.4723 4.87584 41.7852 3.08039 38.8279 1.85544C35.8706 0.630478 32.701 0 29.5 0C26.299 0 23.1294 0.630478 20.1721 1.85544C17.2148 3.08039 14.5277 4.87584 12.2643 7.13927C10.0008 9.4027 8.20539 12.0898 6.98044 15.0471C5.75548 18.0044 5.125 21.174 5.125 24.375C5.125 34.2252 11.1321 42.9975 16.6679 49.0533C19.0692 51.6687 21.6512 54.1095 24.3948 56.3631ZM29.5 33.1771C27.1655 33.1771 24.9267 32.2497 23.276 30.599C21.6253 28.9483 20.6979 26.7095 20.6979 24.375C20.6979 22.0405 21.6253 19.8017 23.276 18.151C24.9267 16.5003 27.1655 15.5729 29.5 15.5729C31.8345 15.5729 34.0733 16.5003 35.724 18.151C37.3747 19.8017 38.3021 22.0405 38.3021 24.375C38.3021 26.7095 37.3747 28.9483 35.724 30.599C34.0733 32.2497 31.8345 33.1771 29.5 33.1771Z",
    fill: "url(#paint1_linear_508_0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_508_0",
    x1: 30,
    y1: 55,
    x2: 30,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_508_0",
    x1: 29.5,
    y1: 0,
    x2: 29.5,
    y2: 60.1629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EBED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.e5809a4ec4e9be8ff143073a50c0efb6.svg";
export { ForwardRef as ReactComponent };